"use client";

import dynamic from "next/dynamic";

// Dynamically import the Snow component and disable server-side rendering
const Snow = dynamic(() => import("@/packages/Snow"), {
  ssr: false,
});

export default function HomeSnow() {
  return <Snow aria-hidden="true" />;
}
